import "./Login.css"
import leftContent from "../../assets/images/login-left-content.png"
import logoLogin from "../../assets/images/logo-login.png"
import { Row, Col, Form, Input, Checkbox, Button, Spin } from "antd";
import { LOGIN_CONSTANT } from "../../constant/login.constant";
import { useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import { useNavigate } from "react-router-dom";
import { errorNotificationAlert } from "../notificationAlert/noticationAlert";
import loginService from "../../service/loginService";
import { useDispatch } from 'react-redux';
import { loginReducerAction } from "../../store/loginReducer";
import { ROUTER_CONSTANT } from "../../constant/router.constant";

const cookies = new Cookies();

const Login = () => {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const [activeSpin, setActiveSpin] = useState(false);
  const dispatch = useDispatch()

  const [loginData, setLoginData] = useState({
    username: null,
    password: null,
  });

  const [rememberValue, setRememberValue] = useState(false);

  const onChangeHandle = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value })
  }

  const onChangeCheckHandle = (e) => {
    setRememberValue({ ...rememberValue, [e.target.name]: e.target.checked })
  }

  const setCookies = (data, dataRememberMe) => {
    cookies.set('username', data.username, { path: '/' });
    cookies.set('remember', dataRememberMe, { path: '/' });
  }

  const removeCookies = (dataRememberMe) => {
    cookies.set('username', null, { path: '/' });
    cookies.set('remember', dataRememberMe, { path: '/' });
  }

  const handleRememberMe = (rememberMeValue) => {
    if (rememberMeValue) {
      setCookies(loginData, rememberMeValue);
    } else {
      removeCookies(rememberMeValue);
    }
  }

  const handleLogin = () => {
    setActiveSpin(true);
    loginService.login(loginData).then((response) => {
      if (response.data.nexsoft.payload.status.success) {
        setActiveSpin(false);
        handleRememberMe(rememberValue);
        dispatch(loginReducerAction.onLogin(response.data.nexsoft.payload.data.content));
        navigate(ROUTER_CONSTANT.HOME);
      }

      if (!response.data.nexsoft.payload.status.success) {
        setActiveSpin(false);
        form.setFields([
          {
            name: 'username',
            errors: [LOGIN_CONSTANT.LOGIN_ERROR_USERNAME],
          },
          {
            name: 'password',
            errors: [LOGIN_CONSTANT.LOGIN_ERROR_PASSWORD],
          },
        ]);
      }
    }).catch((error) => {
      setActiveSpin(false);
      errorNotificationAlert(
        LOGIN_CONSTANT.NOTIFICATION_ERROR_TITLE,
        LOGIN_CONSTANT.NOTIFICATION_ERROR_CONTENT_LOGIN,
        LOGIN_CONSTANT.NOTIFICATION_ERROR_CONTENT_DETAIL_LOGIN
      );
    });
  }

  useEffect(() => {
    let rememberCookies = cookies.get('remember')?.remember || false;
    if (rememberCookies) {
      let usernameCookies = cookies.get('username');
      form.setFieldsValue({
        username: usernameCookies,
        remember: rememberCookies
      });
      setLoginData({ username: usernameCookies, password: null });
      setRememberValue(cookies.get('remember'));
    }
    loginService.logout();
    dispatch(loginReducerAction.onLogout());
  }, [form, dispatch]);

  return (
    <>
      <Row className="container-login">

        <Col className="center-position" span={16}>
          <img className="left-content" src={leftContent} alt="login-left-content" />
        </Col>

        <Col span={8}>
          <div className="right-content-position">
            <img className="right-content-logo" src={logoLogin} alt="logo-login-nextoken" />

            <div className="right-content-text">
              <span>Login Admin</span>
              <div>Enter your credentials to access your account</div>
            </div>
            <br /><br />

            <Form
              form={form}
              onFinish={() => handleLogin()}
            >

              <Row>
                <div className="labelText">
                  Username
                </div>
              </Row>
              <Row>
                <Col span={22}>
                  <Form.Item
                    name="username"
                    rules={[{
                      required: true,
                      message: LOGIN_CONSTANT.VALIDATION_USERNAME,
                      validateTrigger: "onSubmit"
                    }]}
                  >
                    <Input name="username"
                      placeholder={LOGIN_CONSTANT.PLACEHOLDER_USERNAME}
                      onChange={(e) => onChangeHandle(e)} />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <div className="labelText">
                  Password
                </div>
              </Row>
              <Row>
                <Col span={22}>
                  <Form.Item
                    name="password"
                    rules={[{
                      required: true,
                      message: LOGIN_CONSTANT.VALIDATION_PASSWORD,
                      validateTrigger: "onSubmit"
                    }]}
                  >
                    <Input.Password name="password"
                      placeholder={LOGIN_CONSTANT.PLACEHOLDER_PASSWORD}
                      onChange={(e) => onChangeHandle(e)} />
                  </Form.Item>
                </Col>
              </Row>
              <br />

              <Form.Item
                name="remember"
                valuePropName="checked"
              >
                <Checkbox name="remember" onChange={(e) => onChangeCheckHandle(e)}>Remember me</Checkbox>
              </Form.Item>

              <Form.Item
                name="button-login"
              >
                <Row>
                  <Col span={22}>
                    <Spin spinning={activeSpin}>
                      <Button
                        type="primary"
                        className="button-login-style"
                        htmlType="submit"
                      >
                        {LOGIN_CONSTANT.BUTTON_LOGIN}
                      </Button>
                    </Spin>
                  </Col>
                </Row>
              </Form.Item>

            </Form>
          </div>
        </Col>

      </Row>
    </>
  )
}

export default Login;